import React, { memo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';
import parse from 'html-react-parser';

import NoResultsIcon from 'static/images/sidebar/no-results.svg';
import { getResourceTo } from 'react/utils/utils';
import { navigateToUrl } from './utils';

function ResultsList({ breadCumbMenusList, clearSearch }) {
  const resultsListRef = useRef();

  function handleClick(breadCumbItem) {
    breadCumbItem.url && navigateToUrl(breadCumbItem.url);
    clearSearch();
  }

  function onWindowClick(e) {
    if(resultsListRef && resultsListRef.current){
      const element = resultsListRef.current

      if(!element.contains(e.target)){
        clearSearch();
      }
    }
  }

  function getParsedHTML(text) {
    return parse(text);
  }

  useEffect(() => {
    document.addEventListener("click", onWindowClick);

    return () => document.removeEventListener("click", onWindowClick);
  }, []);

  return (
    <div className="results-list" ref={resultsListRef} data-testid="results-list">
      <Tabs>
        <TabList>
          <Tab>
            {getResourceTo('sidebarMenu.search.searchContainer.MenuItemsTab')}
          </Tab>
        </TabList>
        <TabPanel>
          {!breadCumbMenusList.length && (
            <div className="no-results" data-testid="sidebar-search-no-results">
              <img src={NoResultsIcon} alt="No results Icon" />
              <h5>{getResourceTo('sidebarMenu.search.searchContainer.NoResultsTitle')}</h5>
              <p>{getResourceTo('sidebarMenu.search.searchContainer.NoResultsDescription')}</p>
            </div>
          )}
          {
            breadCumbMenusList?.length && (
              <div className="menus-tab-content">
                {breadCumbMenusList.map((item, i) => (
                  <div key={i}>
                    <div className="breadcumb">
                      {
                        item.breadCumbs.map((breadCumbItem, breadCumbIndex) => 
                          <span 
                            data-testid={`${breadCumbItem.url}-breadcumb-item`}
                            key={breadCumbIndex} 
                            onClick={() => handleClick(breadCumbItem)}
                          >
                            {getParsedHTML(breadCumbItem.name)}
                          </span>
                        )
                      }
                    </div>
                    {item.isPinned && (
                      <span 
                        className="breadcumb-icon" 
                        data-testid={`breadcumb-pin-icon-${item.searchedMenu}`} 
                      />
                    )}
                  </div>
                ))}
              </div>
            )
          }
        </TabPanel>
      </Tabs>
    </div>
  );
}

ResultsList.propTypes = {
  clearSearch: PropTypes.func.isRequired,
  breadCumbMenusList: PropTypes.array.isRequired
};

export default memo(ResultsList);